import script from "./EfficiencyFormula.vue?vue&type=script&setup=true&lang=js"
export * from "./EfficiencyFormula.vue?vue&type=script&setup=true&lang=js"

import "./EfficiencyFormula.vue?vue&type=style&index=0&id=8c406ffc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8c406ffc"]])

export default __exports__